/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Button, Select } from '@/ui/index';

import styles from './Filters.module.scss';

const defaultCityValue = {
  name: 'All',
  value: 'all',
};
const defaultOfficeValue = {
  name: 'All',
  value: 0,
};

const Filters = ({
  className = '',
  setTab,
  tab,
  cities,
  offices,
  onFilterChange,
}) => {
  const { t } = useTranslation();

  const mappedData = (data) => {
    const mapped = data?.map((x) => ({
      name: x.name,
      value: x.id,
    }));
    return mapped;
  };
  const [city, setCity] = useState(defaultCityValue);
  const [officeType, setOfficeType] = useState(defaultOfficeValue);
  const cityHandler = (city) => {
    setCity(city);
    onFilterChange({ city, officeType });
  };

  const officeTypeHandler = (office) => {
    setOfficeType(office);
    onFilterChange({ city, officeType: office });
  };

  return (
    <div
      className={`${styles.wrap} ${className || ''} flex-c-c`}
      itemScope
      itemType='https://schema.org/Filter'
    >
      <div className={styles.filtersBlock}>
        <div className={styles.block}>
          <div className={`${styles.filter} flex-c`}>
            <div className={`${styles.buttons} flex-c`}>
              <Button
                onClick={() => setTab('map')}
                className={`${styles.button} ${
                  tab === 'map' ? styles.active : ''
                }`}
                data-testid='office-map'
              >
                {t('common:map')}
              </Button>
              <Button
                onClick={() => setTab('list')}
                className={`${styles.button} ${
                  tab === 'list' ? styles.active : ''
                }`}
                data-testid='office-list'
              >
                {t('common:list')}
              </Button>
            </div>
            <div className={styles.selects}>
              <Select
                value={city}
                data={mappedData(cities)}
                label={t('common:city')}
                className={styles.select}
                onChange={cityHandler}
                data-testid={'filter-city-input'}
              />
              <Select
                value={officeType}
                data={mappedData(offices)}
                label={t('common:offices')}
                className={styles.select}
                onChange={officeTypeHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
